import { Controller, useForm } from 'react-hook-form'
import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
	GradientText,
	StyledTextArea,
	SubmitButton,
	SubmitButtonContainer,
} from '../../PasserCommande/PasserCommande.styles'
import React, { useEffect, useRef, useState } from 'react'

import LayoutChauffeur from '../../../Components/LayoutChauffeur/LayoutChauffeur'
import Modal from 'react-modal'
import TimeField from 'react-simple-timefield'
import UploadMultipleFiles from '../../../Components/UploadMultipleFiles/UploadMultipleFiles'
import { createSignalement } from '../../../api/signalements'
import { getCommande } from '../../../api/commande'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
function NewSignalement(props) {
	const { id } = useParams()
	const history = useHistory()

	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [loading, setLoading] = useState(false)
	const [chargementEnCours, setChargementEnCours] = useState(false);
	const { register, handleSubmit, watch, setValue, control,formState: { errors}} = useForm()
	const [commande, setCommande] = useState()
	const token = useSelector((state) => state.auth.token);
	const user = useSelector((state) => state.auth.user)
	const file = useRef()
	file.current = watch('file', null)

	const type = useRef()
	type.current = watch('type', '')
    const {t} = useTranslation()
	const $getCommande = async (id) => {
		setChargementEnCours(true)
		try {
			const commande = await getCommande(id,token)
			console.log("commande",commande?.courses[0]?.adresse_debut)
			setCommande(commande)
		} catch (error) {
			console.log(error)
		}finally{
			setChargementEnCours(false)

		}
	}

	useEffect(() => {
		$getCommande(id)
	}, [id])

	const onSubmit = async (values) => {
		values.commande= id
		values.chauffeur=user._id
				 
		if ((!values.files || values.files.length === 0)) {
					
					toast.error(
						t("photo_required"),
						{
							style: {
								fontFamily: 'Montserrat',
							},
						}
					)
					return;
		}
		 setLoading(true)
		try {
					await createSignalement(values,token)
					setModalIsOpen(true)
		} catch (error) {
					toast.error(t("error_while_creating_report"),
						{
							style: {
								fontFamily: 'Montserrat',
							},
						}
					)
		}finally{
					setLoading(false)
		}
	}
	const options = [
        { value: '', label: t("select_option"), isDisabled: true },
        { value: 'client_absent', label: 'Client absent' },
        { value: 'retard_aux_chargement', label: t("loading_delay") },
        { value: 'livraison_reportée', label: t("delivery_postponed")},
        { value: 'retard_aux_déchargement', label: t("unloading_delay") },
        { value: 'marchandises_manquantes_chargement', label: t("missing_goods") },
        { value: 'marchandise_refusée', label: t("goods_refused") },
        { value: 'marchandises_incomplètes', label: t("incomplete_goods") },
        { value: 'marchandise_abîmée', label: t("damaged_goods") },
        { value: 'route_inaccessible_fermée', label: t("road_inaccessible") },
        { value: 'circulation_dense', label: t("heavy_traffic") },
        { value: 'anomalie_course', label: t("trip_anomaly") },
        { value: 'autre', label: t("other_specify") },
      ]
const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

	useEffect(() => {
		const checkScreen = () => {
			const width = window.innerWidth;

			setIsMobile(width <= 768);
		};
		checkScreen();
		window.addEventListener('resize', checkScreen);

		return () => window.removeEventListener('resize', checkScreen);
	}, []);
	return (
		<LayoutChauffeur>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					fontFamily: 'Montserrat',
					paddingLeft : '1.5rem',
					paddingRight : '1.5rem'
				}}
			>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<div
							onClick={() => {
								history.goBack()
							}}
							style={{
								background: '#51C7F2',
								width: isMobile ? '1.5rem' : '3rem',
							height: isMobile ? '1.5rem' : '3rem',
								borderRadius: '100%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								cursor: 'pointer',
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width={14.017}
								height={14.11}
								viewBox='0 0 14.017 14.11'
								{...props}
							>
								<g
									data-name='Group 11287'
									fill='none'
									stroke='#fff'
									strokeWidth={2}
								>
									<path
										data-name='Path 11687'
										d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232'
										transform='translate(-8.838 -11.113)'
									/>
									<path
										data-name='Path 11688'
										d='M22.147 11.818l-6.348 6.349 6.348 6.348'
										transform='translate(-8.838 -11.113)'
									/>
								</g>
							</svg>
						</div>

						<div
							style={{
								width: '1rem',
							}}
						/>
						<GradientText marginTop={'unset'}style={{
						fontSize: isMobile ? '1.5rem' : '2.5rem'
					}}>
							{t("add_report").toUpperCase()}
						</GradientText>
					</div>
                    {chargementEnCours ? 
						<div
						style={{
						  display: 'flex',
						  alignItems: 'center',
						  justifyContent: 'center',
						  backgroundColor: 'white',
						  marginTop:"4rem",
						  top: 0,
						  left: 0,
						  right: 0,
						  bottom: 0,
			   
						}}
						>
						<div className='customLoader'></div>	
						</div> 
						: 
						
						<div style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
						}}>
							<div style={{
								width: '100%',
								fontFamily: 'Montserrat',
								alignSelf: 'center',
							}}>
						<form
						 onSubmit={handleSubmit(onSubmit)} >
						
								
							
									<FormSectionCard>
									<div 
										style={{
											display: 'flex',
										    flexDirection: 'column',
											marginBottom: '2rem'}}>
										<span
										    style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: '14px',
											    display: 'block',
												fontWeight: 'bold',
											}}
																			
										>
											{t("select_anomaly_type")} <span style={{ color: 'red' }}>*</span>
										</span>
																		
											<Controller
												name="type"
											    control={control}
												rules={{ required: true }}
										        defaultValue=""
												render={({ field }) => (
													<Select
      {...field}
      options={options}
      value={field.value ? options.find(option => option.value === field.value) : null}
      onChange={(selectedOption) => field.onChange(selectedOption?.value || '')}
     
      placeholder={t("select_option")}  
    />
												)}
											  />
											{errors.type && <p style={{ color: 'red', marginTop: '0.5rem' }}>{t("select_anomaly_type_err")}</p>}
																			
									</div>
									{type.current && (type.current==="retard_aux_chargement" || type.current==="retard_aux_déchargement") && (
												<div>
													<p>
														<b>
															{t("time_anomaly")}{' '}
														</b>
													</p>
													<p>
														{t("enter_delay_time_in_h&m")}  <span style={{ color: 'red' }}>*</span>
													</p>
													<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'center',
														}}
													>
														<Controller
															name='duration'
															rules={{
																required: true,
															}}
															control={control}
															render={({
																field: {
																	onChange,
																	value,
																},
															}) => (
																<TimeField
																	value={
																		value
																	}
																	onChange={(
																		event,
																		value
																	) => {
																		onChange(
																			value
																		)
																	}}
																	input={
																		<input
																			type='text'
																			className='date-input'
																			onFocus={(
																				e
																			) => {
																				e.target.select()
																			}}
																		/>
																	}
																	colon=':'
																/>
															)}
														/>
													</div>
													{errors.duration && 
									                    <p style={{color:'red',marginTop:'0,5rem'}}>{t("enter_delay_time")}</p>}
												</div>
									)}
									{type.current && type.current==="anomalie_course" && 
									<div>
										<p><b>{t("trip_anomaly")}</b></p>
										<p> {t("select_anomaly_trip")}  <span style={{ color: 'red' }}>*</span></p>
									    	<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'center',

														}}
													>
														<Controller
															name='course'
															rules={{
																required: true,
															}}
															control={control}
															render={({
																field: {
																	onChange,
																	value,
																},
															}) => (
														<select
														value={value} 
														onChange={(e) => onChange(e.target.value)}
														style={{
															padding: '1rem',
															borderRadius: '0.5rem',
															color: '#858ea8',
															border: 'none',
															fontFamily: 'Montserrat',
															flex: '1',
															outline: 'none',
															width: '100%',
															
														}}
														>
														<option></option>
														 {/* Première option */}
                                                         <option value={commande?.courses[0]?._id}>
														 {`${t("trip")} ${1}: ${commande?.courses[0]?.adresse_debut.label} --> ${commande?.courses[0]?.adresse_fin.label}`}

                                                         </option>

														 {commande?.courses.length === 2 && (
                                                         <option value={commande?.courses[1]?._id}>
                                                         {`${t("trip")} ${2}: ${commande?.courses[0]?.adresse_fin.label} --> ${commande?.courses[1]?.adresse.label}`}

                                                         </option>
                                                         )}
														{commande?.courses.length>2 &&
														<>
														<option value={commande?.courses[1]?._id}>
														{`${t("trip")} ${2}: ${commande?.courses[0]?.adresse_fin.label} --> ${commande?.courses[1]?.adresse.label}`}
                                                        </option>
														
														{commande?.courses.map((course, index) => (
															index > 1 && (
																<option key={course._id} value={course._id}>
																	{`${t("trip")} ${index+1}: ${commande?.courses[index - 1]?.adresse.label} --> ${course.adresse.label}`}
																</option>
															)
														))}
														</>
                                                         }


														</select>
														)}
														/>
													

													</div>
													{errors.course && 
									                    <p style={{color:'red',marginTop:'0,5rem'}}>{t("select_trip_err")}</p>}
									</div>
                                    } 

									</FormSectionCard>


							
						
					
						
							<FormSectionCard>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										marginBottom: '2.5rem',
										width: '100%',
									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
											fontWeight: 'bold',
										}}
									>
										Note <span style={{ color: 'red' }}>*</span>
									</span>
									<StyledTextArea
										type='text'
										rows={4}
										placeholder=''
										{...register('note', {
											required: true,
										})}
									/>
									{errors.note && 
									<p style={{color:'red',marginTop:'0,5rem'}}>{t("enter_note_err")}</p>}
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										marginBottom: '1rem',
										//width:'100%',
										fontFamily: 'Montserrat',
										// marginLeft: 10,
										// marginTop: 10,
									}}
								>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("attach_images/pdf")}
										</span>
									</div>
									<UploadMultipleFiles
										name='files'
										onChange={(files) =>
											setValue(
												'files',
												files.map((f) => f.id)
											)
										}
										id={commande?._id}

									/>

								</div>
							</FormSectionCard>
							
					

						<div style={{ height: '1rem' }} />
                        {console.log('errroe',errors)}
						<SubmitButtonContainer>
							<SubmitButton type='submit' disabled={loading}>
							{loading ? (
									<div className='loader'></div>
								) : (
									t("add")
								)}
							</SubmitButton>
						</SubmitButtonContainer>
					   </form>
					   </div>
					   </div>
						}
				
				
			</div>

			<Modal
				isOpen={modalIsOpen}
				//onRequestClose={() => setModalIsOpen(false)}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
					},
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						borderRadius: 19,
						background: '#E4EAF0',
						width: isMobile? '90%' : '50%',
					},
				}}
				contentLabel='Modal'
			>
				<div
					style={{
						
						fontFamily: 'Montserrat',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 15,
						textAlign: 'center',
					}}
				>
					<span
						style={{
							color: '#51C7F2',
							fontSize: '25px',
							fontWeight: 'bold',
						}}
					>
						{t("saving")}
					</span>

					<div
						style={{
							marginTop: 20,
						}}
					>
						{t("data_saved_successfully")}
					</div>

					<button
						onClick={() => {
							setModalIsOpen(false)
							history.goBack()
						}}
						style={{
							padding: '1rem 3rem',
							background: '#50F5A9',
							border: 'none',
							cursor: 'pointer',
							color: 'white',
							borderRadius: 7,
							marginTop: 30,
						}}
					>
						OK
					</button>
				</div>
			</Modal>
		</LayoutChauffeur>
	)
}

export default NewSignalement
